const summary = [
  { label: "Total Logs", value: 12, color: "text-blue-600", bg: "bg-blue-100" },
  {
    label: "Successful",
    value: 6,
    color: "text-green-600",
    bg: "bg-green-100",
  },
  {
    label: "Warnings",
    value: 2,
    color: "text-yellow-600",
    bg: "bg-yellow-100",
  },
  { label: "Errors", value: 1, color: "text-red-600", bg: "bg-red-100" },
];

const ActivitySummaryCards = () => {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {summary.map(item => (
        <div
          key={item.label}
          className="rounded-xl border bg-white p-4 shadow-sm"
        >
          <div className="text-sm text-gray-500">{item.label}</div>
          <div className={`mt-1 text-2xl font-semibold ${item.color}`}>
            {item.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivitySummaryCards;
